import { MEDIA_ROOT } from "config.js";

export default function getMediaUrl(path) {
    if (!path) return null;
    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }
    return `${MEDIA_ROOT}${path}`;
}
